module.exports = __webpack_public_path__ + "img/icon_highlight_xiaoxiongmao.9c21d798.png";